/* eslint-disable */

import React from "react";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import DatasetDetailsModal from "./DatasetDetails";
import * as PropTypes from "prop-types";
import { SearchkitManager } from "searchkit";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { Model, pgettext } from "../../shared/utils/legacy";
import APIClient from "../client";

class Legend extends React.Component {
  state = {
    showTaskgridDialog: false,
    showDetails: false,
  };

  static contextTypes = {
    searchkit: PropTypes.instanceOf(SearchkitManager),
  };

  shareLayer = () => {
    const layer = this.props.measurementLayer.layer;
    const measurement_id = this.props.measurementLayer.measurement.id;
    const dataset_did = this.props.measurementLayer.ds.uuid;
    const shareIds = [dataset_did, measurement_id];
    if (layer) {
      shareIds.push(layer.id);
    }
    cropr.shareView.render([shareIds.join(";")]);
  };

  showTaskGrid = () => {
    // $('#modal_spinner span').html(gettext('loading task grid...'));
    // $('#modal_spinner').show();
    let cropfield = this.props.measurementLayer.layer
      ? this.props.measurementLayer.layer.cropfield
      : null;
    if (!cropfield) {
      const searchKit = this.context["searchkit"];
      const thisHit = searchKit.results.hits.hits.find(
        (h) => h._id === this.props.measurementLayer.ds.uuid
      );
      const dr = thisHit._source.data_set_rois.find((dr) => dr.cropfield);
      if (dr) {
        cropfield = dr.cropfield;
      }
    }
    if (!cropfield) {
      this.setState({ showTaskgridDialog: true });
      return;
    }
    const dataType = this.props.measurementLayer.ds.data_type;
    const measurement_id = this.props.measurementLayer.measurement.id;
    const dataset_uuid = this.props.measurementLayer.ds.uuid;
    const cropfield_id = cropfield.id;
    const cropfield_did = cropfield.get("did");
    var record;
    record = new Model.Record({
      processing_state: "planned",
      cropfield: cropfield_id,
    });
    cropr.recording.prescriptionMapView.selectedDataset = this.props.measurementLayer.ds;
    // $('#modal_spinner').hide();
    cropr.recording.render({ record: record });
    cropr.recording.prescriptionMapView.showSelectedDataset(
      dataset_uuid,
      measurement_id,
      dataType,
      cropfield_did
    );
  };

  handleDrawOnMap = (mode) => {
    const options = {
      extra_layer: {
        url: this.props.measurementLayer.data.url,
        bounding_box: this.props.measurementLayer.data.bounding_box,
      },
      return_page: "Cloudfarm",
      return_url: window.location.href,
    };
    window.location.href = `/cropr/farm/plan/#${mode}/options/${encodeURIComponent(
      JSON.stringify(options)
    )}`;
  };
  downloadReport = () => {
    const url = this.props.otherMeasurementLayers.reduce(
      (accumulator, oml) => `${accumulator},${oml.dsUuid}__${oml.measurementId}__${oml.layerId}`,
      `/apps/cloudfarm/export/${this.props.measurementLayer.dsUuid}__${this.props.measurementLayer.measurementId}__${this.props.measurementLayer.layerId}`
    );
    cropr.startExportDownload({ link: url + "/job" });
  };
  downloadCSV = async () => {
    const dsUuid = this.props.measurementLayer.dsUuid;
    const msId = this.props.measurementLayer.measurementId;
    const header = "lat,lon,value\n";
    try {
      let resp = await APIClient.get(
        `/api/data/datasets/${dsUuid}/measurements/${msId}/points/`,
        null,
        cropr.cloudfarm_oauth_token
      );
      const text = resp.map((row) => [row["p"][0], row["p"][1], row["v"]].join(","));
      // Using the File API doesnt seem to work across browsers. Thats why this approach with a hidden element is used.
      const hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(header + text.join("\n"));
      hiddenElement.target = "_blank";
      hiddenElement.download = "measurement.csv";
      hiddenElement.click();
    } catch {
      cropr.notify("danger", gettext("Download failed"));
    }
  };

  render() {
    const legend = this.props.measurementLayer.data.legend;
    const layer = this.props.measurementLayer.layer;
    const measurement = this.props.measurementLayer.measurement;
    const ds = this.props.measurementLayer.ds;
    const imageType = legend ? parseInt(legend[0].image_type) : null;
    const ignore_0 = legend ? legend[0].ignore_0 : null;
    let totalCount = null;
    if (legend && legend[0].count > -1) {
      totalCount = legend.reduce((total, l) => total + l.count, 0);
    }
    let hasTaskGrid = false;
    if (
      ["p", "m", "g"].indexOf(ds.data_format) > -1 ||
      (ds.data_format === "r" && measurement.name.indexOf("RGB") === -1) ||
      (ds.data_type === "satellite" &&
        ["NDVI", "WDVI", "SP", "LEAF_N_CORN", "LEAF_N_POTATO", "MSI", "SAVI"].indexOf(
          measurement.name
        ) > -1) ||
      ds.data_type === "soil potential" ||
      ds.data_type === "elevation"
    ) {
      hasTaskGrid = !cropr.share_mode;
    }
    const canShare = !cropr.share_mode && ["p", "m", "g", "r"].indexOf(ds.data_format) > -1;
    const canPrint = !cropr.share_mode;
    const canDownloadCSV = !cropr.share_mode && ds.data_format === "p"; // point data
    const canDraw = !cropr.share_mode;
    const hasVisualisations = ds.data_format === "p"; // point data
    const hasZoneVisualisation = !!layer && hasTaskGrid && cropr.permissions.staff;
    const hasMore =
      canShare ||
      hasVisualisations ||
      hasTaskGrid ||
      canPrint ||
      canDraw ||
      canDownloadCSV ||
      hasZoneVisualisation;
    return (
      <>
        {this.state.showTaskgridDialog ? (
          <TaskgridModal
            handleHide={() => this.setState({ showTaskgridDialog: false })}
            handleDetails={() =>
              this.setState({
                showTaskgridDialog: false,
                showDetails: true,
              })
            }
            handleDrawOnMap={() => this.handleDrawOnMap("plan")}
            measurementLayer={this.props.measurementLayer}
          />
        ) : null}
        {this.state.showDetails ? (
          <DatasetDetailsModal
            handleHide={() => this.setState({ showDetails: false })}
            dataset={this.props.measurementLayer.ds}
            handleReload={this.props.handleReload}
            tab="geometry"
          />
        ) : null}
        <li className="legend-item d-inline-block float-right clearfix">
          <header>
            <a
              onClick={() => this.props.toggleMeasurementLayer(ds, measurement, layer)}
              className="btn float-right"
            >
              <span aria-hidden="true" style={{ lineHeight: "22px" }}>
                ×
              </span>
            </a>
            {hasMore ? (
              <div className="dropdown float-right">
                <a
                  className="btn dropdown-toggle pl-0"
                  role="button"
                  id="dropdownMore"
                  data-toggle="dropdown"
                  href="#"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  &nbsp;
                </a>
                <ul className="dropdown-menu pt-0 pb-1" aria-labelledby="dropdownMore">
                  {hasVisualisations ? (
                    <li key="visualisations" className="dropdown-submenu">
                      <a
                        id="dropdownVisualisations"
                        tabIndex="-1"
                        href="#"
                        className="dropdown-item dropdown-toggle text-decoration-none text-dark pb-0 pt-1"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i className="icn_eye text-decoration-none text-body pr-2" />{" "}
                        {gettext("Visualisation")}: {visualisations[imageType]}
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="dropdownVisualisations">
                        {[1, 3, 4, 5, 10, 8, 7].map((it) => (
                          <LegendImageTypeSelectItem
                            key={it}
                            measurementLayer={this.props.measurementLayer}
                            imageType={it}
                            ignore_0={ignore_0}
                            isSelected={imageType === it}
                            loadMeasurementLayer={this.props.loadMeasurementLayer}
                          />
                        ))}
                        <div className="dropdown-divider" />
                        <li
                          key="visibility"
                          onClick={() =>
                            this.props.loadMeasurementLayer(
                              this.props.measurementLayer,
                              imageType,
                              !ignore_0
                            )
                          }
                        >
                          <a className="dropdown-item toggle-image text-decoration-none text-dark">
                            <i
                              className={
                                "fas fa-check text-body mr-1 " +
                                (ignore_0 ? "visible" : "invisible")
                              }
                            />
                            {gettext("ignore 0")}
                          </a>
                        </li>
                      </ul>
                    </li>
                  ) : null}
                  {canShare ? (
                    <li key="share">
                      <a
                        className="share-layer dropdown-item text-decoration-none text-dark pb-0 pt-1"
                        href="#"
                        onClick={this.shareLayer}
                      >
                        <i className="icn_share-108 text-body pr-2" />
                        {gettext("Share")}
                      </a>
                    </li>
                  ) : null}
                  {canDraw ? (
                    <div>
                      <li key="draw_on_map">
                        <a
                          className="text-decoration-none text-dark dropdown-item pb-0 pt-1"
                          href="#"
                          onClick={() => this.handleDrawOnMap("plan")}
                        >
                          <i className="far fa-external-link text-body pr-2" />
                          {gettext("Draw on map")}
                        </a>
                      </li>
                      <li key="draw_way_line">
                        <a
                          className="text-decoration-none text-dark dropdown-item pb-0 pt-1"
                          href="#"
                          onClick={() => this.handleDrawOnMap("way_line")}
                        >
                          <i className="far fa-external-link text-body pr-2" />
                          {gettext("Draw way line")}
                        </a>
                      </li>
                    </div>
                  ) : null}
                  {canPrint ? (
                    <li key="print">
                      <a
                        className="dropdown-item text-decoration-none text-dark pb-0 pt-1"
                        href="#"
                        onClick={this.downloadReport}
                      >
                        <i className="far fa-print text-body pr-2" />
                        {gettext("Print report")}
                      </a>
                    </li>
                  ) : null}
                  {canDownloadCSV ? (
                    <li key="csv">
                      <a
                        className="dropdown-item text-decoration-none text-dark pb-0 pt-1"
                        href="#"
                        onClick={this.downloadCSV}
                      >
                        <i className="far fa-external-link text-body pr-2" />
                        {gettext("Download CSV")}
                      </a>
                    </li>
                  ) : null}
                  {hasZoneVisualisation && (
                    <LegendImageTypeSelectItem
                      key={12}
                      measurementLayer={this.props.measurementLayer}
                      imageType={imageType === 12 ? 1 : 12}
                      ignore_0={ignore_0}
                      isSelected={imageType === 12}
                      loadMeasurementLayer={this.props.loadMeasurementLayer}
                      name={pgettext("image type", "Zones")}
                    />
                  )}
                </ul>
              </div>
            ) : null}
            {hasTaskGrid && (
              <a
                onClick={this.showTaskGrid}
                className="btn float-right"
                style={{ lineHeight: "22px" }}
              >
                {gettext("prescription map")}
              </a>
            )}
            <span className="legend-item-description">{measurement.display_name}</span>
            <span className="legend-item-date">{moment(ds.recording_datetime).format("LL")}</span>
            {layer ? (
              <span className="legend-item-parcel">
                <span
                  className="parcel-image"
                  dangerouslySetInnerHTML={{
                    __html: layer.cropfield.getImageTag({
                      size: 24,
                      class: "left",
                    }),
                  }}
                ></span>
                <span className="cropfield-name">{layer.cropfield.get("name")}</span>
              </span>
            ) : (
              ""
            )}
          </header>
          {this.props.updateMeasurementLayer ? (
            <OpacitySlider
              measurementLayer={this.props.measurementLayer}
              onChange={this.props.updateMeasurementLayer}
            />
          ) : null}
          {legend
            ? legend
                .filter((l) => l.c[3] > 0 || l.c.indexOf("#") === 0)
                .map((l, i) => <LegendItem legend={l} key={i} totalCount={totalCount} />)
            : null}
        </li>
      </>
    );
  }
}

export default Legend;

const visualisations = {
  3: pgettext("image type", "Contour 5"),
  8: pgettext("image type", "Contour 20"),
  9: pgettext("image type", "Contour (cubic)"),
  4: pgettext("image type", "Interpolate"),
  1: pgettext("image type", "Points"),
  5: pgettext("image type", "Path"),
  10: pgettext("image type", "Section path"),
  7: pgettext("image type", "Direction"),
  12: pgettext("image type", "Zones"),
};

const LegendImageTypeSelectItem = (props) => {
  return (
    <li
      onClick={() =>
        props.loadMeasurementLayer(props.measurementLayer, props.imageType, props.ignore_0)
      }
    >
      <a className="dropdown-item toggle-image text-decoration-none text-dark">
        <i
          className={"fas fa-check text-body mr-1 " + (props.isSelected ? "visible" : "invisible")}
        ></i>
        {props.name || visualisations[props.imageType]}
      </a>
    </li>
  );
};

const LegendItem = (props) => {
  const legendSpec = props.legend;
  const color = legendSpec.c.indexOf("#") === 0 ? legendSpec.c : "rgba(" + legendSpec.c + ")";
  return (
    <div className="legend-item-list px-0 container w-100">
      <div className="legend-item-list-item small row w-100 m-0">
        <div className="legend-item-specs clearfix">
          <span className="legend-item-spec-color">
            <svg width="20" height="20">
              <rect
                width="20"
                height="20"
                style={{
                  fill: color,
                }}
              ></rect>
            </svg>
          </span>{" "}
          &nbsp;
          <span className="legend-item-spec-numbers">
            {" "}
            {legendSpec["name"]
              ? gettext(legendSpec["name"])
              : `${cropr.toLocaleFixed(legendSpec["min"], 2) || legendSpec["min"]} ${
                  legendSpec["max"] ? " - " + cropr.toLocaleFixed(legendSpec["max"], 2) : ""
                }`}
          </span>
        </div>
        {props.totalCount ? (
          <div className="legend-item-histo clearfix">
            <div className="legend-item-histo-bar-wrapper">
              <span
                className="legend-item-histo-bar"
                style={{
                  width: (legendSpec.count / props.totalCount) * 80 + "px",
                  backgroundColor: color,
                }}
              ></span>
            </div>
            <div className="legend-item-histo-count">{legendSpec.count}</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

const OpacitySlider = (props) => {
  return (
    <div className="opac-slider clearfix">
      <span className="opacity-control">
        <input
          className="slider"
          type="range"
          min="0"
          max="100"
          defaultValue="100"
          onChange={(val) => props.onChange(props.measurementLayer, null, val.target.value / 100)}
        />
      </span>
    </div>
  );
};

class TaskgridModal extends React.Component {
  render() {
    return (
      <Modal show={true} onHide={this.props.handleHide}>
        <Modal.Header closeButton>
          <Modal.Title>{gettext("Task grid")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {gettext(
              "To be able to create a prescription map based on this data, a crop field on the same spot needs to be associated with it."
            )}
          </p>
          <p>{gettext("Click on the button below to create a crop field based on this data.")}</p>
          <p>
            {gettext(
              "Alternatively, you can draw a cropfield on the map, using this image as background."
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.handleDrawOnMap}>
            <i className="far fa-external-link mr-1"></i>
            {gettext("Draw crop field on map")}
          </Button>
          <Button onClick={this.props.handleDetails}>
            {gettext("Create crop field based on data")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
